
function initAnimation() {
  const canvas = document.querySelector('canvas');
  const context = canvas.getContext("2d");
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  const frameCount = 96;
  const to = 96;
  let loadedFrames = 0;
  const currentFrame = index => {
    let prefix = 'xl-';
    if (isMobile) {
      prefix = 'sm-';
    }
    return `https://cdn.shopify.com/s/files/1/0669/6475/0628/files/${prefix}mug-frame-${index}?v=1757419190`
  };

  const images = [];
  const imageSeq = { frame: 1 };
  const from = parseInt(canvas.dataset.from) || 1;
  for (let i = from, j = 1; i <= to; i++, j++) {
    const img = new Image();
    img.src = currentFrame(i);
    images.push(img);

    images[j - 1].onload = () => {
      loadedFrames++;
      if (j === 1) {
        render();
      }
    };
  }

    

  function render() {
    if (loadedFrames !== frameCount) {
      imageSeq.frame = 1;
    }

    const img = images[imageSeq.frame - 1];
    context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);

    const scale = Math.min(
      canvas.clientWidth / img.width,
      canvas.clientHeight / img.height
    );

    const drawWidth = img.width * scale;
    const drawHeight = img.height * scale;
    const x = (canvas.clientWidth - drawWidth) / 2;
    const y = (canvas.clientHeight - drawHeight) / 2;

    context.drawImage(img, x, y, drawWidth, drawHeight);
  }

  const mugScrollDistance = 2700;
  const mugScrollTrigger = {
    trigger: '.mug__img',
    start: 'top bottom',
    end: `+=${mugScrollDistance}`,
    scrub: 1,
  };
  const mugScaleTrigger = {
    ...mugScrollTrigger,
    end: `+=${mugScrollDistance / 4}`,
  };

  gsap.to(imageSeq, {
    frame: frameCount,
    snap: "frame",
    onUpdate: render,
    scrollTrigger: { ...mugScrollTrigger }
  });

  gsap.fromTo(
    canvas,
    {
      y: isTablet ? 30 : 100,
      transformOrigin: 'center center',
    },
    {
      y: isTablet ? -200 : -200,
      ease: 'none',
      scrollTrigger: { ...mugScrollTrigger }
    }
  );
  gsap.fromTo(
    canvas,
    {
      scale: 0.8,
      transformOrigin: 'center center',
    },
    {
      scale: 1,
      ease: 'none',
      scrollTrigger: { ...mugScaleTrigger }
    }
  );

  function resizeCanvas() {
    const dpr = window.devicePixelRatio || 1;
    const cssWidth = canvas.clientWidth;
    const cssHeight = canvas.clientHeight;
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.scale(dpr, dpr);
    render();
  }

  window.addEventListener("resize", resizeCanvas);
  resizeCanvas();
}

document.addEventListener('DOMContentLoaded', initAnimation);
